function MedicalProcedureVO(id, patient, attachments, visitCard, times, date, icd9, additionalNotes, author, modifiedBy,
                            deletedBy, creationDate, modificationDate, deletionDate, deleted, deletionReason, template) {
    this.id = id;

    this.patient = patient;
    this.attachments = attachments;
    this.author = author;
    this.modifiedBy = modifiedBy;
    this.deletedBy = deletedBy;
    this.creationDate = creationDate;
    this.modificationDate = modificationDate;
    this.deletionDate = deletionDate;
    this.deleted = deleted;
    this.deletionReason = deletionReason;

    this.visitCard = visitCard;
    this.times = times;
    this.date = date;
    this.icd9 = icd9;
    this.additionalNotes = additionalNotes;
    this.template = template;

    var _typeContext = {
        visitCard: VisitCardVO,
        date: Date,
        icd9: DictionaryElementVO,
        patient: PatientVO,
        attachments: AttachmentVO,
        author: UserVO,
        modifiedBy: UserVO,
        deletedBy: UserVO,
        creationDate: Date,
        modificationDate: Date,
        deletionDate: Date,
        template: TemplateVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
